import AiChatComposer from "./Composer";
import AiChatMessages from "./Messages";
import { AiChatMessage } from "./types";

type AiChatProps = {
  messages: AiChatMessage[];
  onSubmit: (message: string) => void;
  onStop: () => void;
  isStreaming: boolean;
  focusKey?: number;
};

const AiChat = ({ messages, onSubmit, onStop, isStreaming, focusKey }: AiChatProps) => {
  return (
    <>
      <AiChatMessages messages={messages} />
      <AiChatComposer
        onSubmit={onSubmit}
        onStop={onStop}
        isStreaming={isStreaming}
        focusKey={focusKey}
      />
    </>
  );
};

export default AiChat;
